import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({

	state: {
		product: null,
		products: null,
		profile: null,
		types: null,
		industries: null,
		countries: null,
		relatedCompanies: null
	},
	getters: {
		product: state => {
			return state.product;
		},
		products: state => {
			return state.products;
		},
		profile: state => {
			return state.profile;
		},
		relatedCompanies: state => {
			return state.relatedCompanies;
		},
		types: state => {
			return state.types;
		},
		industries: state => {
			return state.industries;
		},
		getTypeName: (state) => (type_id) => {
			if (!state || !type_id) return null;
			const typeName = state.types.find((type) => type.id === type_id);
			return typeName ? typeName.title : '';
		},
		getIndustryName: (state) => (ind_id) => {
			if (!state || !ind_id) return null;
			const industry = state.industries.find((industry) => industry.id === ind_id);
			return industry ? industry.title : null;
		},
		getCountryName: (state) => (id) => {
			if (!state || !id) return null;
			let countryName = '';
			if (state.countries) {
				countryName = state.countries.find((country) => country.id == id).name;
				return countryName;
			}
			else {
				return countryName;
			}
		},
		isStoreAvailable() {
			return typeof window.marketplace.apiUrl !== 'undefined' && typeof window.marketplace.store_id !== 'undefined';
		},
	},
	mutations: {
		setProduct(state, product) {
			state.product = product;
		},
		setPopularProducts(state, products) {
			state.products = products;
		},
		setProfile(state, profile) {
			state.profile = profile;
		},
		setProfileTypes(state, types) {
			state.types = types;
		},
		setProfileIndustries(state, industries) {
			state.industries = industries;
		},
		setCountries(state, countries) {
			state.countries = countries;
		},
		setRelatedCompanies(state, relatedCompanies) {
			state.relatedCompanies = relatedCompanies;
		}
	},
	actions: {
		setProduct(context, data) {
			context.commit('setProduct', data);
		},
		setPopularProducts(context, data) {
			context.commit('setPopularProducts', data);
		},
		setProfile(context, data) {
			context.commit('setProfile', data);
		},
		setProfileTypes(context, data) {
			context.commit('setProfileTypes', data);
		},
		setProfileIndustries(context, data) {
			context.commit('setProfileIndustries', data);
		},
		setCountries(context, data) {
			context.commit('setCountries', data);
		},
		setRelatedCompanies(context, data) {
			context.commit('setRelatedCompanies', data);
		}
	},
	strict: debug,
});
